import homepageRoute from 'sdss/routes/homepage/homepage'
import searchPageRoute from 'sdss/routes/searchPage/searchPage'

export default [
  ...homepageRoute,
  ...searchPageRoute
]
